<template>
  <div class="simple-code-edit">
    <el-form class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <headline title="基本信息" class="headline" />
      <el-divider class="base-divider" />
      <div style="max-width: 270px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="70px" label="名称：" prop="codeName">
          <el-input class="zwx-input" v-model="mainForm.codeName" maxlength="500" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="编码：" prop="codeNo">
          <el-input class="zwx-input" v-model="mainForm.codeNo" maxlength="20" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="标准编码：">
          <el-input class="zwx-input" v-model="mainForm.standardCode" maxlength="2000" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="排序：">
          <el-input class="zwx-input" v-model="mainForm.num" @input="$validate.nonnegativeInteger($data['mainForm'], 'num')" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <!-- 提交部分 -->
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-28" type="primary" @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交</el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MsCodeSimpleCodeEdit',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      codeTypeId: this.$route.params.codeTypeId,
      parentId: this.$route.params.parentId,
      codeName: this.$route.params.codeName,
      mainForm: {
        codeName: '',
        codeNo: '',
        standardCode: '',
        num: '',
        ifEnable: true,
      },
      rules: {
        codeName: [{ required: true, message: '请输入名称', trigger: ['change', 'blur'] }],
        codeNo: [{ required: true, pattern: /^[^.]+$/, message: '请输入不含小数点的编码', trigger: ['change', 'blur'] }],
      },
    }
  },
  created() {
    if (this.parentId) this.$emit('breadcrumb', '子级添加（' + this.codeName + ')', true)
  },
  mounted() {
    this.detail()
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
  },
  methods: {
    detail() {
      if (this.rid === undefined) return
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getSimpleCode-1', data, true, true, this.detailSuccess, this.detailError)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.mainForm.codeName = data.simpleCode.codeName
        this.mainForm.codeNo = data.simpleCode.codeNo
        this.mainForm.standardCode = data.simpleCode.standardCode
        this.mainForm.num = data.simpleCode.num
        this.mainForm.ifEnable = data.simpleCode.ifEnable
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
        this.back()
      }
    },
    detailError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
      this.back()
    },
    commit() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
        codeType: {
          rid: this.codeTypeId,
        },
        parentId: this.parentId,
        codeName: this.mainForm.codeName,
        codeNo: this.mainForm.codeNo,
        standardCode: this.mainForm.standardCode,
        num: this.mainForm.num,
        ifEnable: this.mainForm.ifEnable,
      }
      if (this.rid) {
        this.$system.postJson(this.api + '/systematic/modifySimpleCode-1', data, true, true, this.commitSuccess, this.commitError)
      } else if (this.parentId) {
        this.$system.postJson(this.api + '/systematic/addSimpleCodeChildren-1', data, true, true, this.commitSuccess, this.commitError)
      } else {
        this.$system.postJson(this.api + '/systematic/addSimpleCode-1', data, true, true, this.commitSuccess, this.commitError)
      }
    },
    commitSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } })
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    commitError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name })
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
